define('gameday-index-gdtracking/src/OmnitureGamedayAsync',['require','exports','module','tracking/omniture'],function(require,exports,module){
    var OmnitureFactory = require( "tracking/omniture" ),
        Omniture = OmnitureFactory.Omniture,
        OmnitureAsync = OmnitureFactory.OmnitureAsync;

    function OmnitureGamedayAsync(props){
        Omniture.call(this,props);
        this.addEvents('event2');
    }

    OmnitureFactory.create(OmnitureGamedayAsync).prototype.fire = OmnitureAsync.prototype.fire;

    return OmnitureGamedayAsync;
}); 
